// (function () {
// 	const searchModal = () => {
// 		$(".search-modal-trigger,.search-modal__overlay,.search__close").click(
// 			function (e) {
// 				e.preventDefault();
// 				searchToggle()
// 			}
// 		);
// 	};
// 	$(document).on('keyup', function(e) {
// 		if ($(".search-modal").hasClass('active') && e.key == "Escape") {
// 			searchToggle()
// 		}
// 	});
// 	function searchToggle(){
// 		$("#search-modal").toggleClass("active");
// 		if ($("#search-modal").hasClass('active')) {
// 			$("#search-modal").find('.search__input').focus();
// 			console.log($("#search-modal").find('.search__input'));
// 		} else {
// 			$(".search-modal-trigger").focus();
// 		}
// 		$('body').toggleClass("overflow-hidden")
// 	}
// 	document.addEventListener("shopify:section:load", searchModal);
// 	searchModal();
// })();



(function () {
	const searchModal = () => {
		$(".search-modal-trigger, .search-modal__overlay, .search__close").click(function (e) {
			e.preventDefault();
			searchToggle();
		});
	};

	$(document).on('keyup', function (e) {
		if ($(".search-modal").hasClass('active') && e.key === "Escape") {
			searchToggle();
		}
	});

	function searchToggle() {
		$("#search-modal").toggleClass("active");
		const searchElement = document.getElementById("search-modal");
		searchElement.dataset.overlayRevision = String(Number(searchElement.dataset.overlayRevision || 0) + 1);

		if ($("#search-modal").hasClass('active')) {
			const inputElement = $("#search-modal").find('.search__input');

			// Adding a small delay before focusing
			setTimeout(() => {
				if (!searchElement.classList.contains("active") || searchElement.inert) return;
				inputElement.focus();

				// Debugging information
				console.log("Search modal is now active.");
				console.log("Attempting to focus the input:", inputElement);
				if (document.activeElement === inputElement[0]) {
					console.log("Input is focused.");
				} else {
					console.log("Input is not focused.");
				}
			}, 100); // Delay of 100 milliseconds
		} else {
			removeTrapFocus();
			$(".search-modal-trigger").focus();
		}

		$('body').toggleClass("overflow-hidden");
		$('html').toggleClass("overflow-hidden");
	}

	document.addEventListener("shopify:section:load", searchModal);
	searchModal();
})();
